<template>
  <div class="app-container withdraw">
    <panelGroup :detail="detail" v-if="detail"/>
    <el-col :span="9">
      <el-input
        v-model="commissionRate"
        placeholder="佣金比例"
        :clearable="true"
        style="width: 200px;margin: 0px 10px;"
      ></el-input>%
      <el-button size="small" type="primary" style="margin-left: 15px;" @click="onSumbit">提交</el-button>
    </el-col>
    <el-col :span="15" style="margin-bottom:15px">
      <div class="header">时间段
        <el-date-picker
          v-model="listQuery.start_datetime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择开始时间"
        ></el-date-picker>
        至
        <el-date-picker
          v-model="listQuery.end_datetime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择结束时间"
        ></el-date-picker>
        <el-button size="small" type="primary" style="margin-left: 15px;" @click="search">搜索</el-button>
      </div>
    </el-col>
    <!-- <div class="fenxiao">￥总产生佣金: {{commission_total}}</div>
    <div class="fenxiao">￥已提现: {{withdrawn_total}}</div>
    <div class="fenxiao">待提现: {{wait_withdrawn_total}}</div>-->
    <el-table
      :loading="listLoading"
      :data="list"
      border=""
      fit
      highlight-current-row
      style="margin-top: 15px;"
    >
      <el-table-column label="序号" align="center" width="95">
        <template slot-scope="scope">{{scope.$index+1}}</template>
      </el-table-column>
      <el-table-column label="店铺名称" align="center" min-width="150">
        <template slot-scope="scope">{{scope.row.shop.name}}</template>
      </el-table-column>
      <el-table-column label="提现金额" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.money}}</template>
      </el-table-column>
      <el-table-column label="实际到账" align="center" min-width="110">
        <template slot-scope="scope">{{(scope.row.money - (commission_rate * scope.row.money)).toFixed(2)}}</template>
      </el-table-column>
      <el-table-column label="扣除佣金" align="center" min-width="110">
        <template slot-scope="scope">{{(commission_rate * scope.row.money).toFixed(2)}}</template>
      </el-table-column>
      <el-table-column label="提现后余额" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.after_balance}}</template>
      </el-table-column>
      <el-table-column label="状态" align="center" min-width="95">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.status==1">待审核</el-tag>
          <el-tag type="info" v-if="scope.row.status==3">拒绝</el-tag>
          <el-tag type="success" v-if="scope.row.status==2">已通过</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="提交时间" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.created_at}}</template>
      </el-table-column>
      <el-table-column label="处理时间" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.updated_at}}</template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="200">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="handlePass(scope.row)"
            v-if="scope.row.status == 1"
          >通过</el-button>
          <el-button
            size="small"
            type="warning"
            @click="handleWatch(scope.row,'watch')"
            v-if="scope.row.status == 2"
          >查看凭证</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        :current-page="listQuery.page"
        :page-size="listQuery.limit"
        :page-sizes="[10,20,30,50]"
        :total="total"
        background=""
        layout="total,sizes,prev,pager,next,jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import panelGroup from "@/components/panelGroup/shopWithdrawIndex.vue";
import request from "@/utils/request";
export default {
  components: {
    panelGroup,
  },
  data() {
    return {
      listLoading: false,
      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
        start_datetime: "",
        end_datetime: "",
        keyword: "",
      },
      list: [],
      // commission_total:0,
      // withdrawn_total:0,
      // wait_withdrawn_total:0,
      commissionRate: "",
      commission_rate:null,
      detail: {
        commission_total: 0,
        withdrawn_total: 0,
        wait_withdrawn_total: 0,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/shop/cashOut",
        method: "get",
        params: this.listQuery,
      })
        .then((result) => {
          this.list = result.data.data;
          this.total = result.data.total;
          // this.commission_total = result.data.commission_total;
          // this.withdrawn_total = result.data.withdrawn_total;
          // this.wait_withdrawn_total = result.data.wait_withdrawn_total;
          this.detail.commission_total = result.data.commission_total;
          this.detail.withdrawn_total = result.data.withdrawn_total;
          this.detail.wait_withdrawn_total = result.data.wait_withdrawn_total;
          this.commissionRate =
            result.data.commission_rate * 100
              ? result.data.commission_rate * 100
              : "";
          this.commission_rate = result.data.commission_rate
          this.listLoading = false;
        })
        .catch((err) => {})
        .finally((err) => {});
    },
    handlePass(val) {
      this.$confirm("此操作将提现通过, 是否继续?", "提示", {
        confirmButtonText: "通过",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/shop/cashOut/agree",
            method: "get",
            params: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    handleWatch(row, type) {
      this.$router.push("/finance/cashout?id=" + row.id + "&type=" + type);
    },
    handlePass(row) {
      this.$router.push("/finance/cashout?id=" + row.id);
    },
    search() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    onSumbit() {
      this.btnLoading = true;
      request({
        url: "/api/backend/setCommissionRate",
        method: "post",
        data: { commissionRate: this.commissionRate },
      })
        .then((response) => {
          this.btnLoading = false;
          this.$notify({
            title: "成功",
            message: "保存成功",
            type: "success",
            duration: 2000,
          });
          this.getList();
        })
        .catch((err) => {
          this.btnLoading = false;
        });
    },
  },
};
</script>

<style>
.fenxiao {
  display: inline-block;
  padding: 20px 30px;
  margin-right: 20px;
  background-color: rgba(255, 0, 0, 0.438);
  color: #ffffff;
  margin-top: 10px;
  border-radius: 30px;
}
</style>
